export default {
  wrapperClass: 'dln-prodReg--search',
  currentStep: 1,
  steps: [
    {
      num: 1,
      label: 'productRegistration:product.registration.breadcrumb.search',
      active: true,
      completed: false,
    },
    {
      num: 2,
      label: 'productRegistration:product.registration.breadcrumb.user-details',
      active: false,
      completed: false,
    },
    {
      num: 3,
      label: 'productRegistration:product.registration.breadcrumb.details',
      active: false,
      completed: false,
    },
  ],
  tabs: [
    {
      id: 'dln-prodReg--model',
      label:
        'productRegistration:product.registration.search.by.term.tab.title',
      isActive: true,
    },
    {
      id: 'dln-prodReg--category',
      label:
        'productRegistration:product.registration.search.by.category.tab.title',
      isActive: false,
    },
  ],
  inputTerm: '',
  inputTermLimit: 3,
  suggestions: [],
  categories: null,
  currentCategoryLevel: 1,
  search: {
    text: null,
    category: null,
  },
  productsLoading: true,
  products: [],
  userDetails: null,
  selectedProduct: null,
  productRegGuid: null,
  isConfirmation: false,
  hasMarketingConsent: false,
};
